'use client'

import { setTheme } from "@/helpers/css.helper";
import styled, { DefaultTheme } from "styled-components";

/** html section styled component */
const StyledSection = styled.section`
    ${({ theme }: { theme: DefaultTheme }) => {
        return setTheme({ component: "section", theme })
    }}
`;

/** html div styled component for row layout */
const StyledRow = styled.div`
    ${({ theme }: { theme: DefaultTheme }) => {
        return setTheme({ component: "row", theme })
    }}
`;

/** html div styled component for column layout */
const StyledColumn = styled.div`
    ${({ theme }: { theme: DefaultTheme }) => {
        return setTheme({ component: "column", theme })
    }}
`;

/** html div styled component for column layout */
const StyledContainer = styled.div`
    ${({ theme }: { theme: DefaultTheme }) => {
        return setTheme({ component: "container", theme })
    }}
`;

// const StyledColumn = styled.div((props: any)=>{
//     console.log("hhhhhhhhh ---- ", props)
//     return ({
//         ...(setTheme({ component: "column", theme: props?.theme || {} })),
//         ...(setTheme({ component: "style", theme: props || {} })),
//         // ...(({theme}: {theme: DefaultTheme}) => {
//         //     return setTheme({ component: "column", theme })
//         // })
//     })
// })


/** html button styled component */
const StyledButton = styled.button`
    ${({ theme }: { theme: DefaultTheme }) => {
        return setTheme({ component: "button", theme })
    }}
`;

/** styled html form element */
const StyledForm = styled.form`
    ${({ theme }: { theme: DefaultTheme }) => {
        return setTheme({ component: "form", theme })
    }}
`;

/** html input styled component */
const StyledInput = styled.input`
    ${({ theme }: { theme: DefaultTheme }) => {
        return setTheme({ component: "input", theme })
    }}
`;

/** html textarea styled component */
const StyledTextArea = styled.textarea`
    ${({ theme }: { theme: DefaultTheme }) => {
        return setTheme({ component: "textarea", theme })
    }}
`;

/** html label styled component */
const StyledLabel = styled.label`
    ${({ theme }: { theme: DefaultTheme }) => {
        return setTheme({ component: "label", theme })
    }}
`;

/** styled nav component to add custom themes */
const StyledNav = styled.nav`
    ${({ theme }: { theme: DefaultTheme }) => {
        return setTheme({ component: "nav", theme })
    }}
`;

/** styled list item component to add custom themes */
const StyledLi = styled.li`
a {
    ${({ theme }: { theme: DefaultTheme }) => {
        return setTheme({ component: "nav", theme })
    }} 
  }
`;

/** html div styled component for displaying Overlay */
// const StyledOverlay = styled.div`
//   background: ${({theme}: {theme: DefaultTheme}) => theme?.overlay?.background},
//   color: ${({theme}: {theme: DefaultTheme}) => theme?.overlay?.color},
//   padding: ${({theme}: {theme: DefaultTheme}) => theme?.overlay?.padding},
//   margin: ${({theme}: {theme: DefaultTheme}) => theme?.overlay?.margin}
// `;
const StyledOverlay = styled.div`
  ${({ theme }: { theme: DefaultTheme }) => {
        return setTheme({ component: "overlay", theme })
    }}
`;

const StyledH1 = styled.h1`
  ${({ theme }: { theme: DefaultTheme }) => {
        return setTheme({ component: "typography", theme })
    }}
`;

const StyledH2 = styled.h2`
  ${({ theme }: { theme: DefaultTheme }) => {
        return setTheme({ component: "typography", theme })
    }}
`;

const StyledH3 = styled.h3`
  ${({ theme }: { theme: DefaultTheme }) => {
        return setTheme({ component: "typography", theme })
    }}
`;

const StyledH4 = styled.h4`
  ${({ theme }: { theme: DefaultTheme }) => {
        return setTheme({ component: "typography", theme })
    }}
`;

const StyledH5 = styled.h5`
  ${({ theme }: { theme: DefaultTheme }) => {
        return setTheme({ component: "typography", theme })
    }}
`;

const StyledH6 = styled.h6`
  ${({ theme }: { theme: DefaultTheme }) => {
        return setTheme({ component: "typography", theme })
    }}
`;

const StyledPaharagraph = styled.p`
  ${({ theme }: { theme: DefaultTheme }) => {
        return setTheme({ component: "typography", theme })
    }}
`;

const StyledDate = styled.span`
  ${({ theme }: { theme: DefaultTheme }) => {
        return setTheme({ component: "date", theme })
    }}
`;

const StyledDiv = styled.div`
    ${({ theme }: { theme: DefaultTheme }) => {
        return setTheme({ component: "div", theme })
    }}
`;

export {
    StyledSection,
    StyledRow,
    StyledColumn,
    StyledContainer,
    StyledButton,
    StyledForm,
    StyledInput,
    StyledTextArea,
    StyledLabel,
    StyledNav,
    StyledLi,
    StyledOverlay,
    StyledH1,
    StyledH2,
    StyledH3,
    StyledH4,
    StyledH5,
    StyledH6,
    StyledPaharagraph,
    StyledDate,
    StyledDiv
};